import React from 'react';
import moment from 'moment';
import dayjs from 'dayjs';

import { withStyles } from '@mui/styles';

import {
  Fab,
  Paper,
  Table,
  Dialog,
  Button,
  Select,
  MenuItem,
  TableRow,
  Checkbox,
  TableHead,
  TableBody,
  InputLabel,
  FormControl,
  DialogTitle,
  DialogContent,
} from '@mui/material';

import AddOutlined from '@mui/icons-material/AddOutlined';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/Delete';
import AccessAlarm from '@mui/icons-material/AccessAlarm';

import Cell from '../../../common/Cell';
import ComponentWrapper from '../../../common/ComponentWrapper';
import TargetAudienceFormula from '../../../common/TargetAudienceFormula';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { TimePicker } from '@mui/x-date-pickers';

import CommonStyles from '../../../common/CommonStyles';
import TrplSelect from '../../../common/TrplControls/TrplSelect';

import { channels } from '../../../constants';

const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const daysShort = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

class BroadcasterPage extends ComponentWrapper {
  constructor() {
    super();

    this.state = {
      subs: [],
      templates: [],
      schedulers: [],
      schedulerEdit: {
        time: new Date(),
        days,
        selectedDays: [],
        timezone: 0,
        timezones: [],
        timezoneKeys: [],
        template: 'none',
        channel: 'auto',
        isOpened: false,
        formula: {
          cons: [],
          ops: [],
        },
      },
      targetAudienceModalOpened: false,
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    this.get({
      url: '/get_jel?type=["brdcst_tsk", "flow"]&meta_query=["setup_contacts_tbox", "account"]',
      cb: (res) => {
        const { schedulerEdit } = this.state;

        const t_box = res._meta_query.setup_contacts_tbox;
        let subs = Object.keys(t_box.nodes).map(concept => res._meta_query.setup_contacts_tbox.nodes[concept]);

        schedulerEdit.timezones = {
          0: "UTC +0",
          1: "UTC +1",
          2: "UTC +2",
          3: "UTC +3",
          4: "UTC +4",
          5: "UTC +5",
          6: "UTC +6",
          7: "UTC +7",
          8: "UTC +8",
          9: "UTC +9",
          10: "UTC +10",
          11: "UTC +11",
          12: "UTC +12",
          '-1': "UTC -1",
          '-2': "UTC -2",
          '-3': "UTC -3",
          '-4': "UTC -4",
          '-5': "UTC -5",
          '-6': "UTC -6",
          '-7': "UTC -7",
          '-8': "UTC -8",
          '-9': "UTC -9",
          '-10': "UTC -10",
          '-11': "UTC -11",
        };
        schedulerEdit.timezone = 0; //`${res._meta_query.account.account_timezone_offset}`

        const schedulers = res.brdcst_tsk || [];

        schedulerEdit.timezoneKeys = Object.keys(schedulerEdit.timezones).sort((a, b) => a - b);

        const templates = res.flow || [];

        this.setState({
          subs,
          schedulers,
          schedulerEdit,
          templates,
        });
      },
    });
  };

  onSchedulerSaveClick = () => {
    const { schedulerEdit, templates } = this.state;

    const { time, timezone, channel, template, selectedDays } = schedulerEdit;

    if (schedulerEdit.formula.action) delete schedulerEdit.formula.action;
    if (schedulerEdit.formula.concept) delete schedulerEdit.formula.concept;

    const schedulerData = {
      channel,
      time: moment(time).format('HH:mm'),
      timezone: timezone,
      template,
      days: selectedDays,
      enabled: true,
      formula: schedulerEdit.formula,
    };

    if (schedulerEdit.id) schedulerData.id = schedulerEdit.id;

    this.postWithData({
      url: '/rest/upd_jel?type=brdcst_tsk',
      data: schedulerData,
      cb: () => {
        this.getData();
      },
    });

    schedulerData.template = templates.find((tmplt) => tmplt.id === template).title;

    this.setState({
      schedulerEdit: {
        time: new Date(),
        days,
        selectedDays: [],
        timezone: 0,
        timezones: [],
        timezoneKeys: [],
        template: 'none',
        channel: 'auto',
      },
    });
  };

  onSchedulerRemoveClick = (id) => {
    this.get({
      url: `/del_jel?id=${id}`,
      cb: () => {
        this.getData();
      },
    });
  };

  onSchedulerCheckboxChange = (e, id) => {
    this.get({
      url: `/enable_jel?id=${id}&enable=${e.target.checked ? '1' : '0'}`,
      cb: () => {
        this.getData();
      },
    });
  };

  onSchedulerTemplateChange = (value) => {
    const { schedulerEdit } = this.state;

    schedulerEdit.template = value;

    this.setState({
      schedulerEdit,
    });
  };

  onSchedulerEditFieldChange = (key, value) => {
    const { schedulerEdit } = this.state;

    schedulerEdit[key] = value;

    this.setState({ schedulerEdit });
  };

  toggleTargetAudienceModal = (val) => {
    this.setState({ targetAudienceModalOpened: val });
  };

  onTargetAudienceSaveClick = (formula) => {
    const { schedulerEdit } = this.state;

    schedulerEdit.formula = formula;

    this.setState({ schedulerEdit });

    this.toggleTargetAudienceModal(false);
  };

  toggleEditDialog(isOpened, sch) {
    let { schedulerEdit } = this.state;

    if (isOpened) {
      if (sch.id) schedulerEdit.id = sch.id;

      const time =
        sch.hours !== undefined && sch.mins !== undefined ? moment().hours(sch.hours).minutes(sch.mins) : moment();

      schedulerEdit.time = time;
      schedulerEdit.selectedDays = sch.days || [];
      schedulerEdit.timezone = sch.timezone;
      schedulerEdit.template = sch.template;
      schedulerEdit.channel = sch.channel;
      schedulerEdit.formula = sch.formula;

      schedulerEdit.isOpened = isOpened;

      this.setState({ schedulerEdit });
    } else {
      schedulerEdit.isOpened = false;

      this.setState({ schedulerEdit }, () => {
        setTimeout(() => {
          schedulerEdit.id = '';
          schedulerEdit.time = new Date();
          schedulerEdit.selectedDays = [];
          schedulerEdit.template = 'none';
          schedulerEdit.channel = 'auto';

          this.setState({ schedulerEdit });
        }, 100);
      });
    }
  }

  onSchedulerEditClick = () => {};

  render() {
    const { subs, templates, schedulers, schedulerEdit, targetAudienceModalOpened } = this.state;

    const { classes } = this.props;

    const templatesKeys = [];
    const editTimezoneKeys = [];

    schedulerEdit.timezoneKeys.forEach((key) =>
      editTimezoneKeys.push({
        title: schedulerEdit.timezones[key],
        value: key,
      })
    );

    templates.forEach((template) => templatesKeys.push({ title: template.title, value: template.id }));

    return (
      <Paper>
        <TargetAudienceFormula
          subs={subs}
          formula={schedulerEdit.formula}
          isOpen={targetAudienceModalOpened}
          onClose={() => this.toggleTargetAudienceModal(false)}
          onSaveClick={this.onTargetAudienceSaveClick}
        />

        <Dialog open={schedulerEdit.isOpened} onClose={() => this.toggleEditDialog(false)}>
          <DialogTitle>{schedulerEdit.id ? 'Edit scheduler' : 'Create scheduler'}</DialogTitle>

          <DialogContent style={{ padding: '10px', overflowY: 'hidden' }}>
            <div className={`${classes.alignCenter} ${classes.mb10}`}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  ampm={false}
                  label="Time"
                  orientation="landscape"
                  value={schedulerEdit.time ? dayjs(Number(schedulerEdit.time)) : null}
                  onChange={(time) => this.onSchedulerEditFieldChange('time', time.$d.getTime())}
                  className={classes.mr10}
                  slotProps={{
                    textField: {
                      variant: 'outlined',
                      InputProps: {
                        classes: {
                          root: classes.schedulerEditTimeInput,
                        },
                      }
                    },
                  }}
                />
              </LocalizationProvider>

              <TrplSelect
                margin="none"
                title="Timezone"
                complicatedValues
                style={{ width: '200px' }}
                value={schedulerEdit.timezone}
                values={editTimezoneKeys}
                onChange={(e) => this.onSchedulerEditFieldChange('timezone', e.target.value)}
              />
            </div>

            <div className={`${classes.alignCenter} ${classes.mb10}`}>
              <TrplSelect
                margin="none"
                title="Template"                
                complicatedValues
                values={templatesKeys}
                style={{ width: '200px' }}
                value={schedulerEdit.template}
                onChange={(e) => this.onSchedulerEditFieldChange('template', e.target.value)}
              />

              <FormControl style={{ flexShrink: 0 }}>
                <InputLabel>Days</InputLabel>

                <Select
                  multiple
                  className={classes.selectContainer}
                  onChange={(e) => this.onSchedulerEditFieldChange('selectedDays', e.target.value)}
                  style={{
                    width: '200px',
                    border: 'none',
                  }}
                  value={schedulerEdit.selectedDays}
                  renderValue={(selected) => (
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                      }}
                    >
                      {selected.map((value, index) => (
                        <div key={index}>{`${daysShort[value - 1]}${index !== selected.length - 1 ? ',' : ''}`}</div>
                      ))}
                    </div>
                  )}
                >
                  {schedulerEdit.days.map((day, index) => {
                    return (
                      <MenuItem
                        key={index}
                        style={{
                          minHeight: '24px',
                          lineHeight: 'normal',
                          fontSize: '12px',
                          padding: '0 16px',
                        }}
                        value={index + 1}
                      >
                        {days[index]}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className={`${classes.alignCenter} ${classes.mb30}`}>
              <div style={{ width: '200px', marginRight: '10px' }}>
                <TrplSelect
                  margin="none"
                  title="Channel"
                  values={['auto', ...channels]}
                  value={schedulerEdit.channel}
                  onChange={(e) => this.onSchedulerEditFieldChange('channel', e.target.value)}
                />
              </div>

              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => this.toggleTargetAudienceModal(true)}
              >
                Set audience
              </Button>
            </div>

            <div className={classes.justifyEnd}>
              <Button
                size="small"
                variant="contained"
                className={classes.mr10}
                onClick={() => this.toggleEditDialog(false)}
              >
                Close
              </Button>

              <Button
                size="small"
                variant="contained"
                type="button"
                color="primary"
                disabled={schedulerEdit.template === 'none' || !schedulerEdit.selectedDays.length}
                onClick={this.onSchedulerSaveClick}
              >
                Save
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <div style={{ overflow: 'auto' }} className={classes.container}>
          <Table>
            <TableHead>
              <TableRow>
                <Cell>Enabled</Cell>
                <Cell>Time</Cell>
                <Cell>Timezone</Cell>
                <Cell>Template</Cell>
                <Cell>Days</Cell>
                <Cell>Audience</Cell>
                <Cell>Channel</Cell>
                <Cell />
              </TableRow>
            </TableHead>

            <TableBody>
              {schedulers.map((sch, index) => {
                const schTemplate = templates.find((tmplt) => tmplt.id === sch.template);

                const schMins = `${sch.mins}`.length === 1 ? '0' + sch.mins : sch.mins;
                const schHours = `${sch.hours}`.length === 1 ? '0' + sch.hours : sch.hours;

                return (
                  <TableRow
                    key={index}
                    style={{
                      opacity: `${sch.enabled ? '1' : '0.5'}`,
                      background: `${sch.enabled ? 'transparent' : '#f4f2f2'}`,
                    }}
                  >
                    <Cell>
                      <Checkbox
                        style={{ width: '19px' }}
                        color="primary"
                        checked={sch.enabled}
                        onChange={(e) => this.onSchedulerCheckboxChange(e, sch.id)}
                      />
                    </Cell>
                    <Cell>
                      <div className={classes.alignCenter}>
                        <AccessAlarm
                          style={{
                            marginRight: '10px',
                            fontSize: '20px',
                          }}
                        />

                        <span>{`${schHours}:${schMins}`}</span>
                      </div>
                    </Cell>
                    <Cell>{schedulerEdit.timezones[sch.timezone]}</Cell>
                    <Cell>
                      <span>{schTemplate ? schTemplate.title : 'Not found'}</span>
                    </Cell>
                    <Cell>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        {sch.days.map((day, index) => {
                          const isLast = index === sch.days.length - 1;
                          return (
                            <span
                              style={{
                                marginBottom: `${isLast ? '0' : '5px'}`,
                              }}
                              key={index}
                            >
                              {days[day - 1]}
                            </span>
                          );
                        })}
                      </div>
                    </Cell>

                    <Cell>
                      <div className={classes.w200}>
                        {sch.formula && sch.formula.cons
                          ? sch.formula.cons.map((concept, conceptIndex) => {
                              const sub = subs.find((sub) => sub.id === concept);

                              if (conceptIndex === 0) {
                                return <span key={conceptIndex}>{sub.title} </span>;
                              }

                              return (
                                <span key={conceptIndex}>
                                  {' '}
                                  {sch.formula.ops[conceptIndex - 1]} {sub.title}
                                </span>
                              );
                            })
                          : null}
                      </div>
                    </Cell>

                    <Cell>{sch.channel || 'Not found'}</Cell>

                    <Cell>
                      <Fab
                        style={{ zoom: '0.8' }}
                        size="small"
                        variant="circular"
                        type="button"
                        color="primary"
                        className={classes.mr10}
                        onClick={() => this.toggleEditDialog(true, sch)}
                      >
                        <Edit />
                      </Fab>

                      <Fab
                        style={{ zoom: '0.8' }}
                        size="small"
                        variant="circular"
                        type="button"
                        color="secondary"
                        onClick={() => this.onSchedulerRemoveClick(sch.id)}
                      >
                        <Delete />
                      </Fab>
                    </Cell>
                  </TableRow>
                );
              })}

              <TableRow>
                <Cell />
                <Cell />
                <Cell />
                <Cell />
                <Cell />
                <Cell />
                <Cell />
                <Cell>
                  <Fab
                    style={{ zoom: '0.8' }}
                    size="small"
                    variant="circular"
                    type="button"
                    color="primary"
                    className={classes.mr10}
                    onClick={() =>
                      this.toggleEditDialog(true, {
                        time: new Date(),
                        selectedDays: [],
                        timezone: 0,
                        template: 'none',
                        channel: 'auto',
                        formula: {
                          cons: [],
                          ops: [],
                        },
                      })
                    }
                  >
                    <AddOutlined />
                  </Fab>
                </Cell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </Paper>
    );
  }
}

const styles = {
  container: {
    padding: '20px',
  },
  selectContainer: {
    border: '1px solid #ededed',
    '& .MuiSelect-selectMenu': {
      background: '#F7F7F7',
      padding: '3px 0 2px 5px',
    },
  },
  select: {
    paddingLeft: '6px',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  schedulerEditTimeInput: {
    height: '24px',
    padding: '0 5px',
    '& .MuiInput-input': {
      padding: '0',
    },
    '&:before': {
      border: 'none',
    },
  },
  ...CommonStyles,
};

export default withStyles(styles)(BroadcasterPage);
